<script setup lang="ts">
import { omit } from '@/shared/utils'
import { twMerge } from 'tailwind-merge'
defineOptions({ inheritAttrs: false })
</script>

<template>
  <div class="size-full bg-surface-secondary">
    <div class="size-full rounded-tl-xl bg-surface-primary">
      <div
        :class="twMerge('container mx-auto size-full px-16 pt-10', String($attrs.class || ''))"
        v-bind="omit($attrs, 'class')"
      >
        <slot />
      </div>
    </div>
  </div>
</template>
